module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "71a2");
/******/ })
/************************************************************************/
/******/ ({

/***/ "064e":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("69b3");
var IE8_DOM_DEFINE = __webpack_require__("db6b");
var toPrimitive = __webpack_require__("94b3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("149f") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "09b9":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("224c");
var defined = __webpack_require__("f6b4");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "0dc8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("064e");
var anObject = __webpack_require__("69b3");
var getKeys = __webpack_require__("80a9");

module.exports = __webpack_require__("149f") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "149f":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("238a")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "163d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("e7ad");
var has = __webpack_require__("e042");
var cof = __webpack_require__("75c4");
var inheritIfRequired = __webpack_require__("1e5b");
var toPrimitive = __webpack_require__("94b3");
var fails = __webpack_require__("238a");
var gOPN = __webpack_require__("2ea2").f;
var gOPD = __webpack_require__("dcb7").f;
var dP = __webpack_require__("064e").f;
var $trim = __webpack_require__("777a").trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__("e005")(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__("149f") ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__("bf16")(global, NUMBER, $Number);
}


/***/ }),

/***/ "18dc":
/***/ (function(module, exports, __webpack_require__) {

// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}


/***/ }),

/***/ "1e5b":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("fb68");
var setPrototypeOf = __webpack_require__("859b").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "224c":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("75c4");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "238a":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "2ea2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("c2f7");
var hiddenKeys = __webpack_require__("ceac").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "4ce5":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("5daa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "4f18":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "550e":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "56f2":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("6798")('keys');
var uid = __webpack_require__("ec45");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "5daa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "6798":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("7ddc");
var global = __webpack_require__("e7ad");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("550e") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "69b3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("fb68");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "71a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/_@vue_cli-service@3.0.3@@vue/cli-service/lib/commands/build/setPublicPath.js
var setPublicPath = __webpack_require__("18dc");

// EXTERNAL MODULE: ./node_modules/_core-js@2.6.11@core-js/modules/es6.number.constructor.js
var es6_number_constructor = __webpack_require__("163d");

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__("c32d");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// CONCATENATED MODULE: ./src/main.js



external_commonjs_vue_commonjs2_vue_root_Vue_default.a.config.productionTip = false;
var LibraryModule = {
  install: function install(Vue, options) {
    // set to custom moment instance else to defaultMoment
    var moment = (options || {}).moment || external_moment_default.a || window.moment;

    if (moment) {
      var modsBetCoinArr_28 = new Array();
      modsBetCoinArr_28[0] = "1,3,6,10,15,21,28,36,45,55,63,69,73,75,75,73,69,63,55,45,36,28,21,15,10,6,3,1"; // 全包

      modsBetCoinArr_28[1] = ",3,,10,,21,,36,,55,,69,,75,,73,,63,,45,,28,,15,,6,,1"; // 单

      modsBetCoinArr_28[2] = ",,,,,,,,,,,,,,,73,,63,,45,,28,,15,,6,,1"; // 大单

      modsBetCoinArr_28[3] = ",3,,10,,21,,36,,55,,69,,75,,,,,,,,,,,,,,"; // 小单

      modsBetCoinArr_28[4] = ",3,,10,,21,,36,,55,,,,,,,,,,45,,28,,15,,6,,1"; // 单边

      modsBetCoinArr_28[5] = "1,,6,,15,,28,,45,,63,,73,,75,,69,,55,,36,,21,,10,,3,"; // 双

      modsBetCoinArr_28[6] = ",,,,,,,,,,,,,,75,,69,,55,,36,,21,,10,,3,"; // 大双

      modsBetCoinArr_28[7] = "1,,6,,15,,28,,45,,63,,73,,,,,,,,,,,,,,,"; // 小双

      modsBetCoinArr_28[8] = "1,,6,,15,,28,,45,,,,,,,,,,55,,36,,21,,10,,3,"; // 双边

      modsBetCoinArr_28[9] = ",,,,,,,,,,,,,,75,73,69,63,55,45,36,28,21,15,10,6,3,1"; // 大

      modsBetCoinArr_28[10] = "1,3,6,10,15,21,28,36,45,55,63,69,73,75,,,,,,,,,,,,,,"; // 小

      modsBetCoinArr_28[11] = ",,,,,,,,,,63,69,73,75,75,73,69,63,,,,,,,,,,"; // 中

      modsBetCoinArr_28[12] = "1,3,6,10,15,21,28,36,45,55,,,,,,,,,55,45,36,28,21,15,10,6,3,1"; // 边

      modsBetCoinArr_28[13] = ",,,,,,,,,,,,,,,,,,55,45,36,28,21,15,10,6,3,1"; // 大边

      modsBetCoinArr_28[14] = "1,3,6,10,15,21,28,36,45,55,,,,,,,,,,,,,,,,,,"; // 小边

      modsBetCoinArr_28[15] = "1,,,,,,,,,,63,,,,,,,,,,36,,,,,,,"; // 0尾

      modsBetCoinArr_28[16] = ",3,,,,,,,,,,69,,,,,,,,,,28,,,,,,"; // 1尾

      modsBetCoinArr_28[17] = ",,6,,,,,,,,,,73,,,,,,,,,,21,,,,,"; // 2尾

      modsBetCoinArr_28[18] = ",,,10,,,,,,,,,,75,,,,,,,,,,15,,,,"; // 3尾

      modsBetCoinArr_28[19] = ",,,,15,,,,,,,,,,75,,,,,,,,,,10,,,"; // 4尾

      modsBetCoinArr_28[20] = ",,,,,21,,,,,,,,,,73,,,,,,,,,,6,,"; // 5尾

      modsBetCoinArr_28[21] = ",,,,,,28,,,,,,,,,,69,,,,,,,,,,3,"; // 6尾

      modsBetCoinArr_28[22] = ",,,,,,,36,,,,,,,,,,63,,,,,,,,,,1"; // 7尾

      modsBetCoinArr_28[23] = ",,,,,,,,45,,,,,,,,,,55,,,,,,,,,"; // 8尾

      modsBetCoinArr_28[24] = ",,,,,,,,,55,,,,,,,,,,45,,,,,,,,"; // 9尾

      modsBetCoinArr_28[25] = "1,3,6,10,15,,,,,,63,69,73,75,75,,,,,,36,28,21,15,10,,,"; // 小尾

      modsBetCoinArr_28[26] = ",,,,,21,28,36,45,55,,,,,,73,69,63,55,45,,,,,,6,3,1"; // 大尾

      modsBetCoinArr_28[27] = "1,,,10,,,28,,,55,,,73,,,73,,,55,,,28,,,10,,,1"; //3%0

      modsBetCoinArr_28[28] = ",3,,,15,,,36,,,63,,,75,,,69,,,45,,,21,,,6,,"; //3%1

      modsBetCoinArr_28[29] = ",,6,,,21,,,45,,,69,,,75,,,63,,,36,,,15,,,3,"; //3%2

      modsBetCoinArr_28[30] = "1,,,,15,,,,45,,,,73,,,,69,,,,36,,,,10,,,"; //4%0

      modsBetCoinArr_28[31] = ",3,,,,21,,,,55,,,,75,,,,63,,,,28,,,,6,,"; //4%1

      modsBetCoinArr_28[32] = ",,6,,,,28,,,,63,,,,75,,,,55,,,,21,,,,3,"; //4%2

      modsBetCoinArr_28[33] = ",,,10,,,,36,,,,69,,,,73,,,,45,,,,15,,,,1"; //4%3

      modsBetCoinArr_28[34] = "1,,,,,21,,,,,63,,,,,73,,,,,36,,,,,6,,"; //5%0

      modsBetCoinArr_28[35] = ",3,,,,,28,,,,,69,,,,,69,,,,,28,,,,,3,"; //5%1

      modsBetCoinArr_28[36] = ",,6,,,,,36,,,,,73,,,,,63,,,,,21,,,,,1"; //5%2

      modsBetCoinArr_28[37] = ",,,10,,,,,45,,,,,75,,,,,55,,,,,15,,,,"; //5%3

      modsBetCoinArr_28[38] = ",,,,15,,,,,55,,,,,75,,,,,45,,,,,10,,,"; //5%4

      var modsBetCoinArr_16 = new Array();
      modsBetCoinArr_16[0] = "1,3,6,10,15,21,25,27,27,25,21,15,10,6,3,1"; // 全包

      modsBetCoinArr_16[1] = "1,,6,,15,,25,,27,,21,,10,,3,"; // 单

      modsBetCoinArr_16[2] = ",,,,,,,,27,,21,,10,,3,"; // 大单

      modsBetCoinArr_16[3] = "1,,6,,15,,25,,,,,,,,,"; // 小单

      modsBetCoinArr_16[4] = "1,,6,,15,,,,,,,,10,,3,"; // 单边

      modsBetCoinArr_16[5] = ",3,,10,,21,,27,,25,,15,,6,,1"; // 双

      modsBetCoinArr_16[6] = ",,,,,,,,,25,,15,,6,,1"; // 大双

      modsBetCoinArr_16[7] = ",3,,10,,21,,27,,,,,,,,"; // 小双

      modsBetCoinArr_16[8] = ",3,,10,,,,,,,,15,,6,,1"; // 双边

      modsBetCoinArr_16[9] = ",,,,,,,,27,25,21,15,10,6,3,1"; // 大

      modsBetCoinArr_16[10] = "1,3,6,10,15,21,25,27,,,,,,,,"; // 小

      modsBetCoinArr_16[11] = ",,,,,21,25,27,27,25,21,,,,,"; // 中

      modsBetCoinArr_16[12] = "1,3,6,10,15,,,,,,,15,10,6,3,1"; // 边

      modsBetCoinArr_16[13] = ",,,,,,,,,,,15,10,6,3,1"; // 大边

      modsBetCoinArr_16[14] = "1,3,6,10,15,,,,,,,,,,,"; // 小边

      modsBetCoinArr_16[15] = ",,,,,,,27,,,,,,,,"; //0尾

      modsBetCoinArr_16[16] = ",,,,,,,,27,,,,,,,"; //1尾

      modsBetCoinArr_16[17] = ",,,,,,,,,25,,,,,,"; //2尾

      modsBetCoinArr_16[18] = "1,,,,,,,,,,21,,,,,"; //3尾

      modsBetCoinArr_16[19] = ",3,,,,,,,,,,15,,,,"; //4尾

      modsBetCoinArr_16[20] = ",,6,,,,,,,,,,10,,,"; //5尾

      modsBetCoinArr_16[21] = ",,,10,,,,,,,,,,6,,"; //6尾

      modsBetCoinArr_16[22] = ",,,,15,,,,,,,,,,3,"; //7尾

      modsBetCoinArr_16[23] = ",,,,,21,,,,,,,,,,1"; //8尾

      modsBetCoinArr_16[24] = ",,,,,,25,,,,,,,,,"; //9尾

      modsBetCoinArr_16[25] = "1,3,,,,,,27,27,25,21,15,,,,"; //小尾

      modsBetCoinArr_16[26] = ",,6,10,15,21,25,,,,,,10,6,3,1"; //大尾

      modsBetCoinArr_16[27] = "1,,,10,,,25,,,25,,,10,,,1"; //3%0

      modsBetCoinArr_16[28] = ",3,,,15,,,27,,,21,,,6,,"; //3%1

      modsBetCoinArr_16[29] = ",,6,,,21,,,27,,,15,,,3,"; //3%2

      modsBetCoinArr_16[30] = ",3,,,,21,,,,25,,,,6,,"; //4%0

      modsBetCoinArr_16[31] = ",,6,,,,25,,,,21,,,,3,"; //4%1

      modsBetCoinArr_16[32] = ",,,10,,,,27,,,,15,,,,1"; //4%2

      modsBetCoinArr_16[33] = "1,,,,15,,,,27,,,,10,,,"; //4%3

      modsBetCoinArr_16[34] = ",,6,,,,,27,,,,,10,,,"; //5%0

      modsBetCoinArr_16[35] = ",,,10,,,,,27,,,,,6,,"; //5%1

      modsBetCoinArr_16[36] = ",,,,15,,,,,25,,,,,3,,"; //5%2

      modsBetCoinArr_16[37] = "1,,,,,21,,,,,21,,,,,1"; //5%3

      modsBetCoinArr_16[38] = ",3,,,,,25,,,,,15,,,,"; //5%4

      var modsBetCoinArr_11 = new Array();
      modsBetCoinArr_11[0] = "10,20,30,40,50,60,50,40,30,20,10"; //全包

      modsBetCoinArr_11[1] = ",20,,40,,60,,40,,20,"; //单

      modsBetCoinArr_11[2] = ",,,,,60,,40,,20,"; //大单

      modsBetCoinArr_11[3] = ",20,,40,,,,,,,"; //小单

      modsBetCoinArr_11[4] = ",20,,,,,,,,20,"; //单边

      modsBetCoinArr_11[5] = "10,,30,,50,,50,,30,,10"; //双

      modsBetCoinArr_11[6] = ",,,,,,50,,30,,10"; //大双

      modsBetCoinArr_11[7] = "10,,30,,50,,,,,,"; //小双

      modsBetCoinArr_11[8] = "10,,30,,,,,,30,,10"; //双边

      modsBetCoinArr_11[9] = ",,,,,60,50,40,30,20,10"; //大

      modsBetCoinArr_11[10] = "10,20,30,40,50,,,,,,"; //小

      modsBetCoinArr_11[11] = ",,,40,50,60,50,40,,,"; //中

      modsBetCoinArr_11[12] = "10,20,30,,,,,,30,20,10"; //边

      modsBetCoinArr_11[13] = ",,,,,,,,30,20,10"; //大边

      modsBetCoinArr_11[14] = "10,20,30,,,,,,,,"; //小边

      modsBetCoinArr_11[15] = ",,,,,,,,30,,"; //0尾

      modsBetCoinArr_11[16] = ",,,,,,,,,20,"; //1尾

      modsBetCoinArr_11[17] = "10,,,,,,,,,,10"; //2尾

      modsBetCoinArr_11[18] = ",20,,,,,,,,,"; //3尾

      modsBetCoinArr_11[19] = ",,30,,,,,,,,"; //4尾

      modsBetCoinArr_11[20] = ",,,40,,,,,,,"; //5尾

      modsBetCoinArr_11[21] = ",,,,50,,,,,,"; //6尾

      modsBetCoinArr_11[22] = ",,,,,60,,,,,"; //7尾

      modsBetCoinArr_11[23] = ",,,,,,50,,,,"; //8尾

      modsBetCoinArr_11[24] = ",,,,,,,40,,,"; //9尾

      modsBetCoinArr_11[25] = "10,20,30,,,,,,30,20,10"; //小尾

      modsBetCoinArr_11[26] = ",,,40,50,60,50,40,,,"; //大尾

      modsBetCoinArr_11[27] = ",20,,,50,,,40,,,10"; //3%0

      modsBetCoinArr_11[28] = ",,30,,,60,,,30,,"; //3%1

      modsBetCoinArr_11[29] = "10,,,40,,,50,,,20,"; //3%2

      modsBetCoinArr_11[30] = ",,30,,,,50,,,,10"; //4%0

      modsBetCoinArr_11[31] = ",,,40,,,,40,,,"; //4%1

      modsBetCoinArr_11[32] = "10,,,,50,,,,30,,"; //4%2

      modsBetCoinArr_11[33] = ",20,,,,60,,,,20,"; //4%3

      modsBetCoinArr_11[34] = ",,,40,,,,,30,,"; //5%0

      modsBetCoinArr_11[35] = ",,,,50,,,,,20,"; //5%1

      modsBetCoinArr_11[36] = "10,,,,,60,,,,,10"; //5%2

      modsBetCoinArr_11[37] = ",20,,,,,50,,,,"; //5%3

      modsBetCoinArr_11[38] = ",,30,,,,,40,,,"; //5%4

      var modsBetCoinArr_7gourd = new Array();
      modsBetCoinArr_7gourd[0] = "7,7,7,7,7,7,7"; // 全包

      modsBetCoinArr_7gourd[1] = "7,,7,,7,,7"; // 单

      modsBetCoinArr_7gourd[2] = ""; // 大单

      modsBetCoinArr_7gourd[3] = ""; // 小单

      modsBetCoinArr_7gourd[4] = ""; // 单边

      modsBetCoinArr_7gourd[5] = ",7,,7,,7,"; // 双

      modsBetCoinArr_7gourd[6] = ""; // 大双

      modsBetCoinArr_7gourd[7] = ""; // 小双

      modsBetCoinArr_7gourd[8] = ""; // 双边

      modsBetCoinArr_7gourd[9] = ",,,7,7,7,7"; // 大

      modsBetCoinArr_7gourd[10] = "7,7,7,,,,"; // 小

      modsBetCoinArr_7gourd[11] = ",,7,7,7,,"; // 中

      modsBetCoinArr_7gourd[12] = "7,7,,,,7,7"; // 边

      modsBetCoinArr_7gourd[13] = ""; // 大边

      modsBetCoinArr_7gourd[14] = ""; // 小边

      modsBetCoinArr_7gourd[15] = ""; // 0尾

      modsBetCoinArr_7gourd[16] = ""; // 1尾

      modsBetCoinArr_7gourd[17] = ""; // 2尾

      modsBetCoinArr_7gourd[18] = ""; // 3尾

      modsBetCoinArr_7gourd[19] = ""; // 4尾

      modsBetCoinArr_7gourd[20] = ""; // 5尾

      modsBetCoinArr_7gourd[21] = ""; // 6尾

      modsBetCoinArr_7gourd[22] = ""; // 7尾

      modsBetCoinArr_7gourd[23] = ""; // 8尾

      modsBetCoinArr_7gourd[24] = ""; // 9尾

      modsBetCoinArr_7gourd[25] = ""; // 小尾

      modsBetCoinArr_7gourd[26] = ""; // 大尾

      var modsBetCoinArr_36 = new Array();
      modsBetCoinArr_36[0] = "1,27,6,36,30"; //全包

      modsBetCoinArr_36[1] = ",27,,36,"; //单

      modsBetCoinArr_36[2] = "1,,6,,30"; //双

      modsBetCoinArr_36[3] = ",,6,36,30"; //大

      modsBetCoinArr_36[4] = "1,27,,,"; //小

      modsBetCoinArr_36[5] = ",27,6,36,"; //中

      modsBetCoinArr_36[6] = "1,,,,30"; //边

      var modsBetCoinArr_longhu = new Array();
      modsBetCoinArr_longhu[0] = "50,50"; //全包

      modsBetCoinArr_longhu[1] = ",50"; //单

      modsBetCoinArr_longhu[2] = "50,"; //双

      modsBetCoinArr_longhu[3] = ",50"; //大

      modsBetCoinArr_longhu[4] = "50,"; //小

      modsBetCoinArr_longhu[5] = ","; //中

      modsBetCoinArr_longhu[6] = ","; //边

      var modsBetCoinArr_pk10 = new Array();
      modsBetCoinArr_pk10[0] = "100,100,100,100,100,100,100,100,100,100"; //全包

      modsBetCoinArr_pk10[1] = "100,,100,,100,,100,,100,"; //单

      modsBetCoinArr_pk10[2] = ",,,,,,100,,100,"; //大单

      modsBetCoinArr_pk10[3] = "100,,100,,100,,,,,"; //小单

      modsBetCoinArr_pk10[4] = "100,,100,,,,,,100,"; //单边

      modsBetCoinArr_pk10[5] = ",100,,100,,100,,100,,100"; //双

      modsBetCoinArr_pk10[6] = ",,,,,100,,100,,100"; //大双

      modsBetCoinArr_pk10[7] = ",100,,100,,,,,,"; //小双

      modsBetCoinArr_pk10[8] = ",100,,,,,,100,,100"; //双边

      modsBetCoinArr_pk10[9] = ",,,,,100,100,100,100,100"; //大

      modsBetCoinArr_pk10[10] = "100,100,100,100,100,,,,,"; //小

      modsBetCoinArr_pk10[11] = ",,,100,100,100,100,,,"; //中

      modsBetCoinArr_pk10[12] = "100,100,100,,,,,100,100,100"; //边

      modsBetCoinArr_pk10[13] = ",,,,,,,100,100,100"; //大边

      modsBetCoinArr_pk10[14] = "100,100,100,,,,,,,"; //小边

      modsBetCoinArr_pk10[15] = ",,,,,,,,,100"; //0尾

      modsBetCoinArr_pk10[16] = "100,,,,,,,,,,"; //1尾

      modsBetCoinArr_pk10[17] = ",100,,,,,,,,,"; //2尾

      modsBetCoinArr_pk10[18] = ",,100,,,,,,,,"; //3尾

      modsBetCoinArr_pk10[19] = ",,,100,,,,,,,"; //4尾

      modsBetCoinArr_pk10[20] = ",,,,100,,,,,,"; //5尾

      modsBetCoinArr_pk10[21] = ",,,,,100,,,,,"; //6尾

      modsBetCoinArr_pk10[22] = ",,,,,,100,,,,"; //7尾

      modsBetCoinArr_pk10[23] = ",,,,,,,100,,,"; //8尾

      modsBetCoinArr_pk10[24] = ",,,,,,,,100,,"; //9尾

      modsBetCoinArr_pk10[25] = "100,100,100,100,,,,,,100"; //小尾

      modsBetCoinArr_pk10[26] = ",,,,100,100,100,100,100,"; //大尾

      modsBetCoinArr_pk10[27] = ",,10,,,10,,,10,"; //3%0

      modsBetCoinArr_pk10[28] = "10,,,10,,,10,,,10"; //3%1

      modsBetCoinArr_pk10[29] = ",10,,,10,,,10,,"; //3%2

      modsBetCoinArr_pk10[30] = ",,,10,,,,10,,"; //4%0

      modsBetCoinArr_pk10[31] = "10,,,,10,,,,10,"; //4%1

      modsBetCoinArr_pk10[32] = ",10,,,,10,,,,10"; //4%2

      modsBetCoinArr_pk10[33] = ",,10,,,,10,,,"; //4%3

      modsBetCoinArr_pk10[34] = ",,,,10,,,,,10"; //5%0

      modsBetCoinArr_pk10[35] = "10,,,,,10,,,,"; //5%1

      modsBetCoinArr_pk10[36] = ",10,,,,,10,,,"; //5%2

      modsBetCoinArr_pk10[37] = ",,10,,,,,10,,"; //5%3

      modsBetCoinArr_pk10[38] = ",,,10,,,,,10,"; //5%4

      var modsBetCoinArr_ca22 = new Array();
      modsBetCoinArr_ca22[0] = "10,10,20,30,40,50,70,80,90,100,100,100,100,90,80,70,50,40,30,20,10,10"; //全包

      modsBetCoinArr_ca22[1] = ",10,,30,,50,,80,,100,,100,,90,,70,,40,,20,,10"; //单

      modsBetCoinArr_ca22[2] = ",,,,,,,,,,,100,,90,,70,,40,,20,,10"; //大单

      modsBetCoinArr_ca22[3] = ",10,,30,,50,,80,,100,,,,,,,,,,,,"; //小单

      modsBetCoinArr_ca22[4] = ",10,,30,,50,,,,,,,,,,70,,40,,20,,10"; //单边

      modsBetCoinArr_ca22[5] = "10,,20,,40,,70,,90,,100,,100,,80,,50,,30,,10,"; //双

      modsBetCoinArr_ca22[6] = ",,,,,,,,,,,,100,,80,,50,,30,,10,"; //大双

      modsBetCoinArr_ca22[7] = "10,,20,,40,,70,,90,,100,,,,,,,,,,,"; //小双

      modsBetCoinArr_ca22[8] = "10,,20,,40,,70,,,,,,,,,,50,,30,,10,"; //双边

      modsBetCoinArr_ca22[9] = ",,,,,,,,,,,100,100,90,80,70,50,40,30,20,10,10"; //大

      modsBetCoinArr_ca22[10] = "10,10,20,30,40,50,70,80,90,100,100,,,,,,,,,,,"; //小

      modsBetCoinArr_ca22[11] = ",,,,,,,80,90,100,100,100,100,90,80,,,,,,,"; //中

      modsBetCoinArr_ca22[12] = "10,10,20,30,40,50,70,,,,,,,,,70,50,40,30,20,10,10"; //边

      modsBetCoinArr_ca22[13] = ",,,,,,,,,,,,,,,70,50,40,30,20,10,10"; //大边

      modsBetCoinArr_ca22[14] = "10,10,20,30,40,50,70,,,,,,,,,,,,,,,"; //小边

      modsBetCoinArr_ca22[15] = ",,,,40,,,,,,,,,,,80,,,,,,,"; //0尾

      modsBetCoinArr_ca22[16] = ",,,,,50,,,,,,,,,,,70,,,,,,"; //1尾

      modsBetCoinArr_ca22[17] = ",,,,,,70,,,,,,,,,,,50,,,,,"; //2尾

      modsBetCoinArr_ca22[18] = ",,,,,,,80,,,,,,,,,,,40,,,,"; //3尾

      modsBetCoinArr_ca22[19] = ",,,,,,,,90,,,,,,,,,,,30,,,"; //4尾

      modsBetCoinArr_ca22[20] = ",,,,,,,,,100,,,,,,,,,,20,,"; //5尾

      modsBetCoinArr_ca22[21] = "10,,,,,,,,,,100,,,,,,,,,10,"; //6尾

      modsBetCoinArr_ca22[22] = ",10,,,,,,,,,,100,,,,,,,,,10"; //7尾

      modsBetCoinArr_ca22[23] = ",,20,,,,,,,,,,100,,,,,,,,"; //8尾

      modsBetCoinArr_ca22[24] = ",,,30,,,,,,,,,,90,,,,,,,"; //9尾

      modsBetCoinArr_ca22[25] = ",,,,40,50,70,80,90,,,,,,80,70,50,40,30,,,"; //小尾

      modsBetCoinArr_ca22[26] = "10,10,20,30,,,,,,100,100,100,100,90,,,,,,20,10,10"; //大尾

      modsBetCoinArr_ca22[27] = "10,,,30,,,70,,,100,,,100,,,70,,,30,,,10"; //3%0

      modsBetCoinArr_ca22[28] = ",10,,,40,,,80,,,100,,,90,,,50,,,20,,"; //3%1

      modsBetCoinArr_ca22[29] = ",,20,,,50,,,90,,,100,,,80,,,40,,,10,"; //3%2

      modsBetCoinArr_ca22[30] = ",,20,,,,70,,,,100,,,,80,,,,30,,,"; //4%0

      modsBetCoinArr_ca22[31] = ",,,30,,,,80,,,,100,,,,70,,,,20,,"; //4%1

      modsBetCoinArr_ca22[32] = "10,,,,40,,,,90,,,,100,,,,50,,,,10,"; //4%2

      modsBetCoinArr_ca22[33] = ",10,,,,50,,,,100,,,,90,,,,40,,,,10"; //4%3

      modsBetCoinArr_ca22[34] = ",,,,40,,,,,100,,,,,80,,,,,20,,"; //5%0

      modsBetCoinArr_ca22[35] = "10,,,,,50,,,,,100,,,,,70,,,,,10,"; //5%1

      modsBetCoinArr_ca22[36] = ",10,,,,,70,,,,,100,,,,,50,,,,,10"; //5%2

      modsBetCoinArr_ca22[37] = ",,20,,,,,80,,,,,100,,,,,40,,,,"; //5%3

      modsBetCoinArr_ca22[38] = ",,,30,,,,,90,,,,,90,,,,,30,,,"; //5%4

      var modsBetCoinArr_feitgy = new Array();
      modsBetCoinArr_feitgy[0] = "2,2,4,4,6,6,8,8,10,8,8,6,6,4,4,2,2"; //全包

      modsBetCoinArr_feitgy[1] = "2,,4,,6,,8,,10,,8,,6,,4,,2"; //单

      modsBetCoinArr_feitgy[2] = ",,,,,,,,,,8,,6,,4,,2"; //大单

      modsBetCoinArr_feitgy[3] = "2,,4,,6,,8,,10,,,,,,,,"; //小单

      modsBetCoinArr_feitgy[4] = "2,,4,,6,,,,,,,,6,,4,,2"; //单边

      modsBetCoinArr_feitgy[5] = ",2,,4,,6,,8,,8,,6,,4,,2,"; //双

      modsBetCoinArr_feitgy[6] = ",,,,,,,,,8,,6,,4,,2,"; //大双

      modsBetCoinArr_feitgy[7] = ",2,,4,,6,,8,,,,,,,,,"; //小双

      modsBetCoinArr_feitgy[8] = ",2,,4,,,,,,,,,,4,,2,"; //双边

      modsBetCoinArr_feitgy[9] = ",,,,,,,,,8,8,6,6,4,4,2,2"; //大

      modsBetCoinArr_feitgy[10] = "2,2,4,4,6,6,8,8,10,,,,,,,,"; //小

      modsBetCoinArr_feitgy[11] = ",,,,,6,8,8,10,8,8,6,,,,,"; //中

      modsBetCoinArr_feitgy[12] = "2,2,4,4,6,,,,,,,,6,4,4,2,2"; //边

      modsBetCoinArr_feitgy[13] = ",,,,,,,,,,,,6,4,4,2,2"; //大边

      modsBetCoinArr_feitgy[14] = "2,2,4,4,6,,,,,,,,,,,,"; //小边

      modsBetCoinArr_feitgy[15] = ",,,,,,,8,,,,,,,,,"; //0尾

      modsBetCoinArr_feitgy[16] = ",,,,,,,,10,,,,,,,,"; //1尾

      modsBetCoinArr_feitgy[17] = ",,,,,,,,,8,,,,,,,"; //2尾

      modsBetCoinArr_feitgy[18] = "2,,,,,,,,,,8,,,,,,"; //3尾

      modsBetCoinArr_feitgy[19] = ",2,,,,,,,,,,6,,,,,"; //4尾

      modsBetCoinArr_feitgy[20] = ",,4,,,,,,,,,,6,,,,"; //5尾

      modsBetCoinArr_feitgy[21] = ",,,4,,,,,,,,,,4,,,"; //6尾

      modsBetCoinArr_feitgy[22] = ",,,,6,,,,,,,,,,4,,"; //7尾

      modsBetCoinArr_feitgy[23] = ",,,,,6,,,,,,,,,,2,"; //8尾

      modsBetCoinArr_feitgy[24] = ",,,,,,8,,,,,,,,,,2"; //9尾

      modsBetCoinArr_feitgy[25] = "2,2,,,,,,8,10,8,8,6,,,,,"; //小尾

      modsBetCoinArr_feitgy[26] = ",,4,4,6,6,8,,,,,,6,4,4,2,2"; //大尾

      modsBetCoinArr_feitgy[27] = "2,,,4,,,8,,,8,,,6,,,2,"; //3%0

      modsBetCoinArr_feitgy[28] = ",2,,,6,,,8,,,8,,,4,,,2"; //3%1

      modsBetCoinArr_feitgy[29] = ",,4,,,6,,,10,,,6,,,4,,"; //3%2

      modsBetCoinArr_feitgy[30] = ",2,,,,6,,,,8,,,,4,,,"; //4%0

      modsBetCoinArr_feitgy[31] = ",,4,,,,8,,,,8,,,,4,,"; //4%1

      modsBetCoinArr_feitgy[32] = ",,,4,,,,8,,,,6,,,,2,"; //4%2

      modsBetCoinArr_feitgy[33] = "2,,,,6,,,,10,,,,6,,,,2"; //4%3

      modsBetCoinArr_feitgy[34] = ",,4,,,,,8,,,,,6,,,,"; //5%0

      modsBetCoinArr_feitgy[35] = ",,,4,,,,,10,,,,,4,,,"; //5%1

      modsBetCoinArr_feitgy[36] = ",,,,6,,,,,8,,,,,4,,"; //5%2

      modsBetCoinArr_feitgy[37] = "2,,,,,6,,,,,8,,,,,2,"; //5%3

      modsBetCoinArr_feitgy[38] = ",2,,,,,8,,,,,6,,,,,2"; //5%4      

      Vue.prototype.$modsBetCoinArr_28 = modsBetCoinArr_28;
      Vue.prototype.$modsBetCoinArr_16 = modsBetCoinArr_16;
      Vue.prototype.$modsBetCoinArr_11 = modsBetCoinArr_11;
      Vue.prototype.$modsBetCoinArr_7gourd = modsBetCoinArr_7gourd;
      Vue.prototype.$modsBetCoinArr_36 = modsBetCoinArr_36;
      Vue.prototype.$modsBetCoinArr_longhu = modsBetCoinArr_longhu;
      Vue.prototype.$modsBetCoinArr_pk10 = modsBetCoinArr_pk10;
      Vue.prototype.$modsBetCoinArr_ca22 = modsBetCoinArr_ca22;
      Vue.prototype.$modsBetCoinArr_feitgy = modsBetCoinArr_feitgy;

      Vue.prototype.$tool = function (val) {
        return val;
      };

      Vue.prototype.$doubleNumber = function (val) {
        if (typeof val === 'number') {
          return val * 2;
        } else if (!isNaN(Number(val))) {
          return Number(val) * 2;
        } else {
          return null;
        }
      }; //根据值返回对应的颜色


      Vue.prototype.$getColorName = function (val) {
        var color = "";
        if (val > 0) color = "red";else if (val < 0) color = "green";else {
          color = "#ff734f";
        }
        return color;
      };

      Vue.prototype.$getGameGroupName = function (gameType) {
        var gName = "";

        if (gameType == "g1" || gameType == "g2" || gameType == "g3" || gameType == "g6" || gameType == "g7" || gameType == "g8" || gameType == "gz" || gameType == "xy28" || gameType == "xy16" || gameType == "xy11" || gameType == "xy10" || gameType == "xy36" || gameType == "xy22" || gameType == "xygd") {
          gName = "xy";
        } else if (gameType == "m1" || gameType == "m2" || gameType == "m3" || gameType == "m4") {
          gName = "mk";
        }

        return gName;
      };

      Vue.prototype.$getGameGroupType = function (gameType) {
        var gName = "";

        if (gameType == "k3" || gameType == "c3" || gameType == "h3" || gameType == "y3" || gameType == "g7" || gameType == "k8" || gameType == "d3" || gameType == "q4") {
          gName = "sl";
        }

        return gName;
      };

      Vue.prototype.$getGameArrayZero = function (gameType) {
        var gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);

        if (gameType == "g2" || gameType == "k2" || gameType == "c2" || gameType == "h2" || gameType == "y2" || gameType == "q2" || gameType == "k7" || gameType == "d2" || gameType == "t2" || gameType == "m2") {
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else if (gameType == "g3" || gameType == "k4" || gameType == "h4" || gameType == "q3" || gameType == "c5" || gameType == "t3" || gameType == "m3") {
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else if (gameType == "p1" || gameType == "p2" || gameType == "c4" || gameType == "g6" || gameType == "y4" || gameType == "k6" || gameType == "h5" || gameType == "d4" || gameType == "f1" || gameType == "f2" || gameType == "t4" || gameType == "m3") {
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else if (gameType == "p3" || gameType == "g8" || gameType == "f4") {
          //p3=22
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else if (gameType == "k3" || gameType == "c3" || gameType == "h3" || gameType == "y3" || gameType == "g7" || gameType == "k8" || gameType == "d3" || gameType == "q4") {
          gm = new Array(0, 0, 0, 0, 0);
        } else if (gameType == "f3" || gameType == "p4") {
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        } else if (gameType == "p5" || gameType == "f5") {
          gm = new Array(0, 0);
        } else {
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        }

        return gm;
      };

      Vue.prototype.$getRightTimes = function (gameType) {
        var gm = new Array(1000, 333, 166, 100, 66, 48, 36, 28, 22, 18, 16, 15, 14, 13, 13, 14, 15, 16, 18, 22, 28, 36, 48, 66, 100, 166, 333, 1000);

        if (gameType == "g2" || gameType == "k2" || gameType == "c2" || gameType == "h2" || gameType == "y2" || gameType == "q2" || gameType == "k7" || gameType == "d2" || gameType == "t2" || gameType == "m2") {
          gm = new Array(216, 72, 36, 21, 14, 10, 8, 8, 8, 8, 10, 14, 21, 36, 72, 216);
        } else if (gameType == "g3" || gameType == "k4" || gameType == "h4" || gameType == "q3" || gameType == "c5" || gameType == "t3" || gameType == "m3") {
          gm = new Array(36, 18, 12, 9, 7, 6, 7, 9, 12, 18, 36);
        } else if (gameType == "p1" || gameType == "p2" || gameType == "c4" || gameType == "g6" || gameType == "y4" || gameType == "k6" || gameType == "h5" || gameType == "d4" || gameType == "f1" || gameType == "f2" || gameType == "t4" || gameType == "m4") {
          gm = new Array(10, 10, 10, 10, 10, 10, 10, 10, 10, 10);
        } else if (gameType == "p3" || gameType == "g8" || gameType == "f4") {
          //p3=22
          gm = new Array(120, 120, 60, 40, 30, 24, 17, 15, 13, 12, 12, 12, 12, 13, 15, 17, 24, 30, 40, 60, 120, 120);
        } else if (gameType == "k3" || gameType == "c3" || gameType == "h3" || gameType == "y3" || gameType == "g7" || gameType == "k8" || gameType == "d3" || gameType == "q4") {
          gm = new Array(100, 4, 17, 3, 3);
        } else if (gameType == "f3" || gameType == "p4") {
          gm = new Array(44.9900, 45.0000, 22.4900, 22.5000, 14.9900, 15.0000, 11.2400, 11.2500, 8.9900, 11.2500, 11.2400, 15.0000, 14.9900, 22.5000, 22.4900, 45.0000, 44.9900);
        } else if (gameType == "p5" || gameType == "f5") {
          gm = new Array(2.0000, 2.0000);
        } else {
          gm = new Array(1000, 333, 166, 100, 66, 48, 36, 28, 22, 18, 16, 15, 14, 13, 13, 14, 15, 16, 18, 22, 28, 36, 48, 66, 100, 166, 333, 1000);
        }

        return gm;
      };

      Vue.prototype.$getGameParamForP = function (gameType, param) {
        var betmods = modsBetCoinArr_28;
        var Numberlength = 27;
        var Snum = 0;
        var mZhongbian1 = 9;
        var mZhongbian2 = 18;
        var isHasZhongbian = true;
        var mDaxiao = 13;
        var allNo = true;
        var gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        var rightTimes = new Array(1000, 333, 166, 100, 66, 48, 36, 28, 22, 18, 16, 15, 14, 13, 13, 14, 15, 16, 18, 22, 28, 36, 48, 66, 100, 166, 333, 1000);
        var bztz = new Array(1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 63, 69, 73, 75, 75, 73, 69, 63, 55, 45, 36, 28, 21, 15, 10, 6, 3, 1);

        if (gameType == "g2" || gameType == "k2" || gameType == "c2" || gameType == "h2" || gameType == "y2" || gameType == "q2" || gameType == "k7" || gameType == "d2" || gameType == "t2" || gameType == "m2") {
          betmods = modsBetCoinArr_16;
          Numberlength = 16;
          Snum = 3;
          mZhongbian1 = 7;
          mZhongbian2 = 14;
          isHasZhongbian = true;
          mDaxiao = 10;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(216, 72, 36, 21, 14, 10, 8, 8, 8, 8, 10, 14, 21, 36, 72, 216);
          bztz = new Array(1, 3, 6, 10, 15, 21, 25, 27, 27, 25, 21, 15, 10, 6, 3, 1);
        } else if (gameType == "g3" || gameType == "k4" || gameType == "k9" || gameType == "h4" || gameType == "q3" || gameType == "c5" || gameType == "t3" || gameType == "m3") {
          betmods = modsBetCoinArr_11;
          Numberlength = 11;
          Snum = 2;
          mZhongbian1 = 4;
          mZhongbian2 = 10;
          isHasZhongbian = true;
          mDaxiao = 6;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(36, 18, 12, 9, 7, 6, 7, 9, 12, 18, 36);
          bztz = new Array(10, 20, 30, 40, 50, 60, 50, 40, 30, 20, 10);
        } else if (gameType == "p1" || gameType == "p2" || gameType == "c4" || gameType == "g6" || gameType == "y4" || gameType == "k6" || gameType == "h5" || gameType == "d4" || gameType == "f1" || gameType == "f2" || gameType == "t4" || gameType == "m4") {
          betmods = modsBetCoinArr_pk10;
          Numberlength = 10;
          Snum = 1;
          mZhongbian1 = 3;
          mZhongbian2 = 8;
          isHasZhongbian = true;
          mDaxiao = 5;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(10, 10, 10, 10, 10, 10, 10, 10, 10, 10);
          bztz = new Array(100, 100, 100, 100, 100, 100, 100, 100, 100, 100);
        } else if (gameType == "p3" || gameType == "g8" || gameType == "f4") {
          //p3=22
          betmods = modsBetCoinArr_ca22;
          Numberlength = 22;
          Snum = 6;
          mZhongbian1 = 12;
          mZhongbian2 = 21;
          isHasZhongbian = true;
          mDaxiao = 16;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(120, 120, 60, 40, 30, 24, 17, 15, 13, 12, 12, 12, 12, 13, 15, 17, 24, 30, 40, 60, 120, 120);
          bztz = new Array(10, 10, 20, 30, 40, 50, 70, 80, 90, 100, 100, 100, 100, 90, 80, 70, 50, 40, 30, 20, 10, 10);
        } else if (gameType == "k3" || gameType == "c3" || gameType == "h3" || gameType == "y3" || gameType == "g7" || gameType == "k8" || gameType == "d3" || gameType == "q4") {
          betmods = modsBetCoinArr_36;
          Numberlength = 5;
          Snum = 0;
          mZhongbian1 = 1;
          mZhongbian2 = 4;
          isHasZhongbian = true;
          allNo = false;
          gm = new Array(0, 0, 0, 0, 0);
          rightTimes = new Array(100, 4, 17, 3, 3);
          bztz = new Array(1, 27, 6, 36, 30);
        } else if (gameType == "f3" || gameType == "p4") {
          betmods = modsBetCoinArr_feitgy;
          Numberlength = 17;
          Snum = 3;
          mZhongbian1 = 7;
          mZhongbian2 = 14;
          isHasZhongbian = true;
          mDaxiao = 10;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(44.9900, 45.0000, 22.4900, 22.5000, 14.9900, 15.0000, 11.2400, 11.2500, 8.9900, 11.2500, 11.2400, 15.0000, 14.9900, 22.5000, 22.4900, 45.0000, 44.9900);
          bztz = new Array(2, 2, 4, 4, 6, 6, 8, 8, 10, 8, 8, 6, 6, 4, 4, 2, 2);
        } else if (gameType == "p5" || gameType == "f5") {
          betmods = modsBetCoinArr_longhu;
          Numberlength = 2;
          Snum = 1;
          mZhongbian1 = 1;
          mZhongbian2 = 2;
          isHasZhongbian = false;
          mDaxiao = 1;
          allNo = false;
          gm = new Array(0, 0);
          rightTimes = new Array(2.0000, 2.0000);
          bztz = new Array(50, 50);
        } else {
          //|| gameType=="gz" || gameType=="kz" || gameType=="kx" || gameType=="cz" || gameType=="qz" || gameType=="hz"
          betmods = modsBetCoinArr_28;
          Numberlength = 28;
          Snum = 0;
          mZhongbian1 = 9;
          mZhongbian2 = 18;
          isHasZhongbian = true;
          mDaxiao = 13;
          allNo = true;
          gm = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          rightTimes = new Array(1000, 333, 166, 100, 66, 48, 36, 28, 22, 18, 16, 15, 14, 13, 13, 14, 15, 16, 18, 22, 28, 36, 48, 66, 100, 166, 333, 1000);
          bztz = new Array(1, 3, 6, 10, 15, 21, 28, 36, 45, 55, 63, 69, 73, 75, 75, 73, 69, 63, 55, 45, 36, 28, 21, 15, 10, 6, 3, 1);
        }

        if (param == 0) return betmods;else if (param == 1) return Numberlength;else if (param == 2) return Snum; //开始号码
        else if (param == 3) return mZhongbian1;else if (param == 4) return mDaxiao;else if (param == 5) return mZhongbian2;else if (param == 6) return isHasZhongbian;else if (param == 7) return allNo;else if (param == 8) return gm;else if (param == 9) return rightTimes;else if (param == 10) return bztz; //标准投注
          else return 0;
      };
    } else {
      throw new Error("A momentJS instance was not found.");
    }
  }
}; // Automatically register library if Vue is available globally

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(LibraryModule);
}

/* harmony default export */ var main = (LibraryModule);
// CONCATENATED MODULE: ./node_modules/_@vue_cli-service@3.0.3@@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main);



/***/ }),

/***/ "75c4":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "777a":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("e46b");
var defined = __webpack_require__("f6b4");
var fails = __webpack_require__("238a");
var spaces = __webpack_require__("9769");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "7ddc":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "80a9":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("c2f7");
var enumBugKeys = __webpack_require__("ceac");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "859b":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("fb68");
var anObject = __webpack_require__("69b3");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("4ce5")(Function.call, __webpack_require__("dcb7").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "86d4":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("064e");
var createDesc = __webpack_require__("cc33");
module.exports = __webpack_require__("149f") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8df1":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("e7ad").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "94b3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("fb68");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "9769":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "b3a6":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("09b9");
var toLength = __webpack_require__("eafa");
var toAbsoluteIndex = __webpack_require__("f58a");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "bf16":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e7ad");
var hide = __webpack_require__("86d4");
var has = __webpack_require__("e042");
var SRC = __webpack_require__("ec45")('src');
var $toString = __webpack_require__("d07e");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("7ddc").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "bfe7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("fb68");
var document = __webpack_require__("e7ad").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "c2f7":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("e042");
var toIObject = __webpack_require__("09b9");
var arrayIndexOf = __webpack_require__("b3a6")(false);
var IE_PROTO = __webpack_require__("56f2")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "c32d":
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "cc33":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "ceac":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "d07e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("6798")('native-function-to-string', Function.toString);


/***/ }),

/***/ "db6b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("149f") && !__webpack_require__("238a")(function () {
  return Object.defineProperty(__webpack_require__("bfe7")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "dcb7":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("4f18");
var createDesc = __webpack_require__("cc33");
var toIObject = __webpack_require__("09b9");
var toPrimitive = __webpack_require__("94b3");
var has = __webpack_require__("e042");
var IE8_DOM_DEFINE = __webpack_require__("db6b");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("149f") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "e005":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("69b3");
var dPs = __webpack_require__("0dc8");
var enumBugKeys = __webpack_require__("ceac");
var IE_PROTO = __webpack_require__("56f2")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("bfe7")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("8df1").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "e042":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "e46b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e7ad");
var core = __webpack_require__("7ddc");
var hide = __webpack_require__("86d4");
var redefine = __webpack_require__("bf16");
var ctx = __webpack_require__("4ce5");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "e7ad":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "eafa":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("ee21");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "ec45":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "ee21":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "f58a":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("ee21");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "fb68":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ })

/******/ });
//# sourceMappingURL=vue-moment-dbb.common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-moment-dbb@1.0.7@vue-moment-dbb/dist/vue-moment-dbb.common.js
// module id = m990
// module chunks = 39